// Hand-rolled line-icon set for Transportes CGMG.
// Consistent 24x24 grid, currentColor stroke, rounded caps — no icon-library
// dependency, so the whole set shares one weight and personality.

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const paths = {
  training: (
    <>
      <path d="M2.5 8.5 12 4l9.5 4.5L12 13 2.5 8.5Z" />
      <path d="M6.5 10.6v4.4c0 1.4 2.4 3 5.5 3s5.5-1.6 5.5-3v-4.4" />
      <path d="M21 9v6" />
    </>
  ),
  handshake: (
    <>
      <path d="M2.5 11.5 6 8l3 1.7" />
      <path d="M21.5 11.5 18 8l-3 1.7" />
      <path d="M9 9.7l2.2 1.9a1.4 1.4 0 0 0 1.9-.1v0a1.4 1.4 0 0 0-.1-2L11 8" />
      <path d="M9 9.7 6 12.3l3.4 3.4c.6.6 1.6.6 2.2 0" />
      <path d="M15 9.7l3 2.6-3.4 3.4c-.6.6-1.6.6-2.2 0l-2.2-2" />
    </>
  ),
  warehouse: (
    <>
      <path d="M3 10.5 12 4l9 6.5" />
      <path d="M4.5 9.5V20h15V9.5" />
      <path d="M9.5 20v-5.5h5V20" />
    </>
  ),
  gps: (
    <>
      <circle cx="12" cy="11" r="3" />
      <path d="M12 2.5c4.4 0 7.5 3.3 7.5 7.3 0 4.8-5 9.3-7 10.9a1 1 0 0 1-1 0c-2-1.6-7-6.1-7-10.9 0-4 3.1-7.3 7.5-7.3Z" />
    </>
  ),
  price: (
    <>
      <path d="M12.7 3.5h5.8a1 1 0 0 1 1 1v5.8a1 1 0 0 1-.3.7l-8.9 8.9a1 1 0 0 1-1.4 0l-6.1-6.1a1 1 0 0 1 0-1.4l8.9-8.9a1 1 0 0 1 .7-.3Z" />
      <circle cx="16.2" cy="7.8" r="1.3" />
    </>
  ),
  report: (
    <>
      <path d="M7 3.5h8.5L19 7v13.5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1Z" />
      <path d="M15.2 3.5V7H19" />
      <path d="M8.5 12.5l2.3 2.3L15.5 10" />
    </>
  ),
  shield: (
    <>
      <path d="M12 3 19 5.5v5c0 5-3 8.3-7 10-4-1.7-7-5-7-10v-5L12 3Z" />
      <path d="M9 11.8 11.2 14 15.3 9.6" />
    </>
  ),
  box: (
    <>
      <path d="M12 3.5 20.5 8 12 12.5 3.5 8 12 3.5Z" />
      <path d="M3.5 8v8.5L12 21l8.5-4.5V8" />
      <path d="M12 12.5V21" />
    </>
  ),
  snow: (
    <>
      <path d="M12 2.5v19M4 7l16 10M4 17 20 7" />
      <path d="M12 2.5 9.7 4.8M12 2.5l2.3 2.3M12 21.5l-2.3-2.3M12 21.5l2.3-2.3" />
      <path d="M4 7l3.1.3L8 4.3M4 7l1 3-2.8 1.4M20 7l-3.1.3L16 4.3M20 7l-1 3 2.8 1.4M4 17l3.1-.3L8 19.7M4 17l1-3-2.8-1.4M20 17l-3.1-.3L16 19.7M20 17l-1-3 2.8-1.4" />
    </>
  ),
  warehouse2: (
    <>
      <rect x="4" y="5" width="16" height="15" rx="1.2" />
      <path d="M12 8.5v6" />
      <path d="M9 11.7 12 14.5l3-2.8" />
      <path d="M4 20h16" />
    </>
  ),
  radar: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <circle cx="12" cy="12" r="5" opacity="0.55" />
      <circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none" />
      <path d="M12 12 18 7.5" />
    </>
  ),
  route: (
    <>
      <circle cx="5.5" cy="18.5" r="2" />
      <circle cx="18.5" cy="5.5" r="2" />
      <path d="M7.3 17.3C11 14 9 10 12 8c2.2-1.4 3.7.4 4.8-.8" />
    </>
  ),
  phone: (
    <path d="M5 3.5h3.2l1.3 4-2 1.5a12 12 0 0 0 6.5 6.5l1.5-2 4 1.3V18a2 2 0 0 1-2.2 2 17 17 0 0 1-14.3-14.3A2 2 0 0 1 5 3.5Z" />
  ),
  whatsapp: (
    <>
      <path d="M4 20.5 5.2 16A8.5 8.5 0 1 1 8.6 19l-4.6 1.5Z" />
      <path d="M8.7 8.6c.2-.5.4-.5.7-.5h.5c.2 0 .4 0 .6.4.2.5.7 1.6.7 1.8.1.1.1.3 0 .4-.1.2-.2.3-.3.4l-.4.5c-.2.1-.3.3-.1.6.2.3.8 1.2 1.7 2 1.1 1 2 1.3 2.3 1.4.3.1.5.1.6-.1l.6-.7c.2-.2.4-.2.6-.1l1.6.8c.2.1.4.2.4.4.1.2.1.9-.2 1.4-.3.6-1.5 1.1-2.1 1.1-.6 0-1.2.1-4-1.1-3.3-1.5-5.4-4.9-5.6-5.1-.1-.2-1.3-1.7-1.3-3.3 0-1.6.8-2.3 1.1-2.7Z" />
    </>
  ),
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="1.5" />
      <path d="M4 6.5 12 13l8-6.5" />
    </>
  ),
  mapPin: (
    <>
      <path d="M12 21.5c-4-3.6-7-7.6-7-11.3A7 7 0 0 1 19 10.2c0 3.7-3 7.7-7 11.3Z" />
      <circle cx="12" cy="10" r="2.4" />
    </>
  ),
  menu: (
    <>
      <path d="M3.5 6.5h17" />
      <path d="M3.5 12h17" />
      <path d="M3.5 17.5h17" />
    </>
  ),
  close: (
    <>
      <path d="M5 5l14 14" />
      <path d="M19 5 5 19" />
    </>
  ),
  arrowRight: (
    <>
      <path d="M4 12h16" />
      <path d="M14 6l6 6-6 6" />
    </>
  ),
  chevronDown: <path d="M5.5 8.5 12 15l6.5-6.5" />,
  truck: (
    <>
      <path d="M2.5 7.5h10v8H2.5z" />
      <path d="M12.5 10.5h4.2l3.3 3v2H12.5z" />
      <circle cx="6.3" cy="17" r="1.7" />
      <circle cx="16.3" cy="17" r="1.7" />
    </>
  ),
  check: <path d="M5 12.5 9.5 17 19 6.5" />,
  clock: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3.2 2" />
    </>
  ),
  building: (
    <>
      <rect x="5" y="3.5" width="14" height="17" rx="1" />
      <path d="M8.5 7.5h1.2M14.3 7.5h1.2M8.5 11.5h1.2M14.3 11.5h1.2M8.5 15.5h1.2M14.3 15.5h1.2" />
      <path d="M10.3 20.5V17h3.4v3.5" />
    </>
  ),
  sparkle: (
    <>
      <path d="M12 3.5c.4 2.7 1 4.3 2.1 5.4 1.1 1.1 2.7 1.7 5.4 2.1-2.7.4-4.3 1-5.4 2.1-1.1 1.1-1.7 2.7-2.1 5.4-.4-2.7-1-4.3-2.1-5.4-1.1-1.1-2.7-1.7-5.4-2.1 2.7-.4 4.3-1 5.4-2.1 1.1-1.1 1.7-2.7 2.1-5.4Z" />
    </>
  ),
};

export function Icon({ name, size = 24, className, title, ...rest }) {
  const content = paths[name];
  if (!content) return null;
  return (
    <svg
      {...base}
      width={size}
      height={size}
      className={className}
      role={title ? "img" : "presentation"}
      aria-hidden={title ? undefined : true}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      {content}
    </svg>
  );
}

export default Icon;
